import QorusClient from "@/api/clients/QorusClient";
import { Product, ProductsWithFilters } from "@/models/product";
import { AxiosRequestConfig } from "axios";
import qs from "qs";

export default class ProductApi {
  static of(): ProductApi {
    return new ProductApi();
  }

  /**
   * Gets all products according to a given pagination
   * @param categoryId category Id
   * @param page Page to retrieve
   * @param pageSize Number of products by page
   * @param sort Attribute used for sorting
   * @param asc True (ascending) / False (descending)
   * @return Page<LightProductDTO> Paginated products
   */
  getByCategory(categoryId: string, query: any): Promise<ProductsWithFilters> {
    //v1/products?category=<category>
    //v1/products/categories/<category>
    // page = 0, pageSize = 10, sort = "price", asc = true;
    const defaultSort = process.env.VUE_APP_DEFAULT_SORT;
    const sort = query.sort?.split(".")[0] || defaultSort.split(".")[0];
    const sortOrder = query.sort?.split(".")[1] || defaultSort.split(".")[1];
    const filters = query.filters || null;

    return QorusClient.client.get("products/category", {
      paramsSerializer: function (params) {
        return qs.stringify(params, { indices: false }); // param=value1&param=value2
      },
      params: {
        categoryPath: categoryId,
        size: query.itemsPerPage || 24,
        page: query.page - 1 || 0,
        sort: sort + "," + sortOrder,
        filters,
      },
    }).then(
      (data: ProductsWithFilters) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  getBestSeller(categoryId: string): Promise<ProductsWithFilters> {
    //v1/products?category=<category>
    //v1/products/categories/<category>
    // page = 0, pageSize = 10, sort = "price", asc = true;

    return QorusClient.client.get("products/category", {
      params: {
        categoryPath: categoryId,
        size: 10,
        page: 0,
        sort: "relevance,asc",
      },
    }).then(
      (data: ProductsWithFilters) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  getBySlug(slug: string): Promise<Product> { /* TODO */
    return QorusClient.client.get(`products/slug/` + slug).then(
      (data: Product) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  search(searchTerm: string): Promise<ProductsWithFilters> { /* TODO */
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        searchTerm,
        size: 4,
      },
    };
    return QorusClient.client.get(`products/search`, axiosRequestConfig).then(
      (data: ProductsWithFilters) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  searchPage(query: any): Promise<ProductsWithFilters> { /* TODO */

    const defaultSort = process.env.VUE_APP_DEFAULT_SORT;
    const sort = query.sort?.split(".")[0] || defaultSort.split(".")[0];
    const sortOrder = query.sort?.split(".")[1] || defaultSort.split(".")[1];
    const filters = query.filters || null;

    const axiosRequestConfig: AxiosRequestConfig = {
      paramsSerializer: function (params) {
        return qs.stringify(params, { indices: false }); // param=value1&param=value2
      },
      params: {
        searchTerm: query.searchTerm,
        size: query.itemsPerPage || 24,
        page: query.page - 1 || 0,
        sort: sort + "," + sortOrder,
        filters,
      },
    };
    return QorusClient.client.get(`products/search`, axiosRequestConfig).then(
      (data: ProductsWithFilters) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  searchAutocomplete(searchTerm: string): Promise<Array<string>> { /* TODO */
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        searchTerm,
        size: 10,
      },
    };
    return QorusClient.client.get(`products/search-autocomplete`, axiosRequestConfig).then(
      (data) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

  getBySkuList(referenceList: string): Promise<any> {
    const axiosRequestConfig: AxiosRequestConfig = {
      params: {
        referenceList,
      },
    };
    return QorusClient.client.get(`/products/references`, axiosRequestConfig).then(
      (data) => {
        return data;
      },
      err => {
        throw err;
      },
    );
  }

  restockAlert(form): Promise<any> {
    return QorusClient.client.post("products/offer/restock-alert", form).then(
      (data: any) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }

}
